"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HelpCenterArticleListItem = void 0;
var react_1 = __importDefault(require("react"));
var ContentfulRichText_1 = __importDefault(require("../../../../utils/ContentfulRichText"));
var typography_1 = require("../../../../typography");
var Link_1 = __importDefault(require("../../../../navigation/Link"));
var styles_1 = require("./styles");
var RICH_TEXT_OVERRIDES = {
    paragraph: function (_, children) { return react_1.default.createElement(styles_1.Answer, null, children); },
    'heading-1': function (_, children) { return react_1.default.createElement(typography_1.Heading, { level: "3" }, children); },
    'heading-2': function (_, children) { return react_1.default.createElement(typography_1.Heading, { level: "4" }, children); },
    'heading-3': function (_, children) { return react_1.default.createElement(typography_1.Heading, { level: "5" }, children); },
    hyperlink: function (node, children) {
        var url = node.data.uri;
        // const isExternal = !url.includes(MARKETING_SITE_URL);
        // const parsedUrl = isExternal ? url : url.split(MARKETING_SITE_URL)[1];
        return (react_1.default.createElement(Link_1.default, { href: url, isExternal: true }, children));
    },
};
var HelpCenterArticleListItem = function (_a) {
    var id = _a.id, title = _a.title, body = _a.body, _b = _a.isActive, isActive = _b === void 0 ? false : _b, _c = _a.headingLevel, headingLevel = _c === void 0 ? 2 : _c, onClick = _a.onClick, commonProps = __rest(_a, ["id", "title", "body", "isActive", "headingLevel", "onClick"]);
    return (react_1.default.createElement(styles_1.Wrapper, __assign({ "data-component-name": "HelpCenterArticleListItem" }, commonProps),
        react_1.default.createElement(styles_1.QuestionWrapper, { id: "help-center-title-".concat(id), color: "BLUE_50", hoverColor: "BLUE_60", onClick: function () { return onClick(id); } },
            react_1.default.createElement(typography_1.Heading, { level: "4", maxWidth: 26, as: "h".concat(headingLevel.toString()) }, title),
            react_1.default.createElement(styles_1.Close, { "$isActive": isActive })),
        react_1.default.createElement(styles_1.AnswerWrapper, { isActive: isActive },
            react_1.default.createElement(ContentfulRichText_1.default, { nodeOverrides: RICH_TEXT_OVERRIDES }, body))));
};
exports.HelpCenterArticleListItem = HelpCenterArticleListItem;
exports.default = exports.HelpCenterArticleListItem;
